import { render } from "./membership-result.vue?vue&type=template&id=3b9e94d8"
import script from "./membership-result.vue?vue&type=script&lang=js"
export * from "./membership-result.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__